module.exports = __webpack_public_path__ + "img/section2_pic2@2x.5784e105.png";